import React from 'react';
import { setCurrentView } from 'core/utils';
import { DuplicateReportViewStore } from 'modules/order/stores';
import { DuplicateReportTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new DuplicateReportViewStore(rootStore, componentProps),
	'duplicateReportViewStore'
)
class DuplicateReport extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <DuplicateReportTemplate {...this.props} />;
	}
}

export default DuplicateReport;
